import { Section, SectionColumn } from '@powerportalspro/react-fluent';
import { NumberRangesMainSample } from '../charts/NumberRangesMainSample';
import { NumberRangesSeriesSample } from '../charts/NumberRangesSeriesSample';

// Two charts over the contacts, each grouping their age in ranges of as many years as its dropdown
// says. The first counts the contacts in each range (`groupByRangeSize`), a bar for every range
// from the youngest contact's to the oldest's. The second counts them by gender and stacks each
// bar by age range (`seriesRangeSize`). They are the Number Ranges documentation page's own
// samples, `NumberRangesMainSample` and `NumberRangesSeriesSample`.

export function NumberRangesShowcaseMainSample() {
  return (
    <Section borderVisible={false}>
      <SectionColumn>
        <NumberRangesMainSample />
      </SectionColumn>
      <SectionColumn>
        <NumberRangesSeriesSample />
      </SectionColumn>
    </Section>
  );
}
